<template lang="html">
  <div class="attribute-list row">
    <div class="col-12 col-sm-6">
      <ul class="attribute-column list-group list-group-flush">
        <template v-for="(attr, index) in attributes.filter((_, p) => !(p % 2))">
          <li
            :key="'attrList-odd-' + index"
            :style="attributes.length === 1 && 'border-bottom: 1px solid rgba(0, 0, 0, 0.125);'"
            class="custom list-group-item row justify-content-between px-2">
            <div class="attribute-name col">{{ attr.name }}</div>
            <div class="attribute-value col"><strong>{{ attr.setted_value }}</strong></div>
          </li>
        </template>
      </ul>
    </div>
    <div class="col-12 col-sm-6">
      <ul class="attribute-column list-group list-group-flush">
        <template v-for="(attr, index) in attributes.filter((_, p) => p % 2)">
          <li
            :key="'attrList-even-' + index"
            :style="attributes.length === 3 && 'border-bottom: 1px solid rgba(0, 0, 0, 0.125);'"
            class="custom list-group-item row justify-content-between px-2">
            <div class="attribute-name col">{{ attr.name }}</div>
            <div class="attribute-value col"><strong>{{ attr.setted_value }}</strong></div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  computed: {
    attributes: () => store.getters['sell/attributes']
      .map(attribute => ({
        ...attribute,
        name: store.state.sell.fetchedAttributes
          .find(fetchedAttr => fetchedAttr.id === attribute.id).name
      }))
  }
}
</script>

<style lang="scss">
  //.attribute-list {
  //  & .custom {
  //    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
  //  }
  //}

  .attribute {
    &-column {
      padding-right: 0.75rem;
      padding-left: 0.75rem;
    }

    &-list {
      & .custom {
        display: inline-flex;
        border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
      }
    }

    &-name {
      max-width: fit-content;
      padding: 0 0.25rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    &-value {
      max-width: fit-content;
      padding: 0 0.25rem;
      text-align: end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/AttributesList.vue